module.exports = __webpack_public_path__ + "img/CrossImage.0063fb6b.png";